var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccueilmultilingue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multilingue"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.07,16.91a.82.82,0,0,0-.3-.6,18.27,18.27,0,0,0-9.87-4.12c-.6-.06-1.21-.09-1.82-.09h0c-.61,0-1.22,0-1.82.09a18.31,18.31,0,0,0-13.53,8.2h0a18.38,18.38,0,0,0,1.19,21.79.83.83,0,0,0,.6.3h0a.82.82,0,0,0,.59-.25l24.71-24.7A.87.87,0,0,0,45.07,16.91ZM30.36,29.65H25.23a24.77,24.77,0,0,1,1-6.29,54.11,54.11,0,0,0,6,.43v4Zm-14,0a16.53,16.53,0,0,1,2.39-7.82,50.33,50.33,0,0,0,5.82,1.28,26.33,26.33,0,0,0-1,6.54ZM31.71,13.83l.52,0v8.33a51.76,51.76,0,0,1-5.42-.38A24.3,24.3,0,0,1,31.71,13.83Zm-3,17.49-3.15,3.15a23.83,23.83,0,0,1-.31-3.15Zm5.21-7.53c.8,0,1.6,0,2.41-.09L33.9,26.1Zm4.23-1.92c-1.4.14-2.82.23-4.23.25V13.79l.52,0A24.45,24.45,0,0,1,39,21Zm-9-7.64a26.09,26.09,0,0,0-4.05,7.27,51.55,51.55,0,0,1-5.36-1.13A16.61,16.61,0,0,1,29.17,14.23ZM19.61,40.39a16.69,16.69,0,0,1-3.23-9.07h7.17a27.15,27.15,0,0,0,.55,4.58ZM40.29,19.71A26,26,0,0,0,37,14.23,16.43,16.43,0,0,1,43,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.44,20.4a18.82,18.82,0,0,0-1.2-1.62.83.83,0,0,0-1.17-.11l-.06,0L21.31,43.43a.83.83,0,0,0,0,1.18s0,0,.05,0a18.27,18.27,0,0,0,9.87,4.12,18.71,18.71,0,0,0,3.51,0V53a.83.83,0,0,0,.83.84.85.85,0,0,0,.62-.27l7.49-8.12A18.38,18.38,0,0,0,48.44,20.4ZM42.65,44.18l-.14.11-6.1,6.62V47.85a.84.84,0,0,0-.84-.83h-.12l-.71.09a16.94,16.94,0,0,1-3.34,0,16.58,16.58,0,0,1-8.25-3.17L46.52,20.57c.18.25.36.49.52.74A16.72,16.72,0,0,1,42.65,44.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 33.07,
    cy: 38.84,
    r: 1.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 38.08,
    cy: 38.84,
    r: 1.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 43.09,
    cy: 38.84,
    r: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.68,41.77a.83.83,0,0,0-.93.73l-.07.56a21.72,21.72,0,0,1,2.43-28,.84.84,0,0,0,0-1.18.83.83,0,0,0-1.18,0h0A23.41,23.41,0,0,0,12.27,44l-.7-.11a.84.84,0,0,0-1,.71.83.83,0,0,0,.7.94l2.82.42a.84.84,0,0,0,.95-.7v0l.32-2.51a.84.84,0,0,0-.73-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.8,16.28a.85.85,0,0,0,.84-.84.84.84,0,0,0-.84-.83H51.3a.83.83,0,0,0-.84.83V18a.84.84,0,0,0,1.67,0v-.28A21.72,21.72,0,0,1,50,45.77.84.84,0,0,0,50,47a.83.83,0,0,0,1.18,0,23.4,23.4,0,0,0,2-30.67Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccueilmultilingue);
export default __webpack_public_path__ + "static/media/accueilmultilingue.386633abe2fa346f36a4f95f38e9594a.svg";
export { ForwardRef as ReactComponent };